import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {AlertController, Content, Events, IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {StatusBar} from "@ionic-native/status-bar";
import {ReaderService} from "../../providers/reader.service";
import {DeviceSelectPage} from "../device-select/device-select";
import {CycleCountService} from "../../providers/cyclecount.service";
import {
  DEFAULT_APP_NAME,
  DEFAULT_APP_VERSION, NAV_PARAM_BACK_TO_MENU, NAV_PARAM_RETURN_PAGE,
  SIMULATOR_READER_ADDRESS,
  SIMULATOR_READER_BATTERY,
  SIMULATOR_READER_MANUFACTURER,
  SIMULATOR_READER_MAX_POWER,
  SIMULATOR_READER_MIN_POWER,
  SIMULATOR_READER_MODEL,
  SIMULATOR_READER_NAME,
  SIMULATOR_READER_SOUND_LEVELS,
  SIMULATOR_READER_TYPE,
  STORAGE_READER_SOUND_LEVEL,
  STORAGE_TIME_OFFSET
} from "../../app/app.constants";
import {AppVersion} from "@ionic-native/app-version";
import {SimulatorService} from "../../providers/simulator.service";
import {Storage} from "@ionic/storage";
import {VizixEventService} from "../../providers/vizix.event.service";
import {VizixService} from "../../providers/vizix.service";
import {Subscription} from "rxjs/Subscription";
import {ReaderThingConfiguration} from "../../models/ReaderThingConfiguration";
import {DatePipe} from '@angular/common';
import {isUndefined} from "util";

/**
 * Generated class for the AppConfigPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-config',
  templateUrl: 'app-config.html',
  providers: [DatePipe]
})
export class AppConfigPage {

  private tag = '[APP_CONFIG]';
  public readerVolume: number;
  public readerName: string = "";
  public appName: string = "";
  public appVersionString: string = "";
  public os: string = "";
  public isReaderConnected: boolean = false;
  public isSimulatorEnabled: boolean = false;
  public isCycleCountRunning: boolean = false;
  public maxLevelSound: number = 10;

  private appProperties: any = [];
  private readerProperties: any = [];
  public mapReaderProperties = {};

  private cycleCountProgress: number = 0;
  private readerDisconnectSubscription: Subscription;
  private suscReaderStopScanCC: Subscription;
  private suscReaderIsConnected: Subscription;
  private suscReaderGetConfig: Subscription;
  private suscReaderDisconected: Subscription;

  private returnPage: string;
  private isAlertShowing: boolean = false;
  public fromDeviceSelect: boolean = false;
  public timeoutTicks: Array<any> = [];

  @ViewChild(Content) content: Content;
  private isPopActive: boolean = false;
  private firstReaderInformationWasUpdated: boolean = false;

  private cycleCountInterval;

  private isIosVersionLessThan11:boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public statusBar: StatusBar,
              private storage: Storage,
              private _alertCtrl: AlertController,
              private readerService: ReaderService,
              private cdr: ChangeDetectorRef,
              public platform: Platform,
              public cycleCountService: CycleCountService,
              private appVersion: AppVersion,
              private simulatorService: SimulatorService,
              private vizixEventService: VizixEventService,
              private vizixService: VizixService,
              private events: Events,
              private datePipe: DatePipe) {

    this.fromDeviceSelect = this.navParams.get('fromDeviceSelect');
    this.returnPage = this.navParams.get('returnPage');
    // this.backColor = this.navParams.get('backColor');
    platform.ready().then(() => {

      if (this.platform.is('android')) {
        this.os = "Android";
        this.isIosVersionLessThan11=false;
      } else if (this.platform.is('ios')) {
        this.os = "iOS";
        const osVersionNumber=this.platform.version().num;
        this.isIosVersionLessThan11 = osVersionNumber < 11;
      } else if (this.platform.is('mobileweb')) {
        this.os = "Browser";
        this.isIosVersionLessThan11=false;
      } else {
        this.os = "Browser";
        this.isIosVersionLessThan11=false;
      }

    });

    this.isSimulatorEnabled = this.simulatorService.isSimulatorEnabled;

  }

  ionViewDidLoad() {

    this.getAppInformation();
    this.checkIfReaderIsConnected();
    this.initCycleCountProgress();
  }

  ionViewWillEnter() {
    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
    this.initReaderStatusListener();
  }

  initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      if (response.hasOwnProperty('connected') && !response.connected) {
        console.log(this.tag, 'Reader disconnected!');
        this.isReaderConnected = false;
      }
      // if (response.hasOwnProperty('connected')) {
      //   this.checkIfReaderIsConnected();
      // }

    });
  }

  ionViewDidEnter() {
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.events.subscribe('time:changed', () => {
      console.log('time changed, updating...');
      this.updateClocks();
    });
  }

  unsubscribeEvents() {
    this.events.unsubscribe('time:changed', () => {
      console.log('time changed, updating...');
      this.updateClocks();
    });
  }

  ionViewWillLeave() {
    this.unsubscribeEvents();
    this.unSubscribeObservables();
    this.clearTimeouts();
  }

  unSubscribeObservables() {
    if (this.readerDisconnectSubscription) {
      this.readerDisconnectSubscription.unsubscribe();
    }
    if (this.suscReaderGetConfig) {
      this.suscReaderGetConfig.unsubscribe();
    }
    if (this.suscReaderDisconected) {
      this.suscReaderDisconected.unsubscribe();
    }
    if (this.suscReaderIsConnected) {
      this.suscReaderIsConnected.unsubscribe();
    }
    if (this.suscReaderStopScanCC) {
      this.suscReaderStopScanCC.unsubscribe();
    }
  }


  clearTimeouts() {
    if (this.timeoutTicks && Array.isArray(this.timeoutTicks) && this.timeoutTicks.length) {
      this.timeoutTicks.forEach((tick) => {
        if (tick) {
          clearTimeout(tick);
        }
      });
    }
    this.timeoutTicks = [];

    clearInterval(this.cycleCountInterval);
  }

  private stopReader() {
    console.log(this.tag, 'Stopping reader');
    this.suscReaderStopScanCC = this.readerService.stopScanCC().subscribe(
      () => {
      },
      (error) => {
        console.log(this.tag, error);
      });
  }

  /*initReaderStatusListener() {
    console.log(this.tag, 'Initializing Reader Status Listener');
    this.readerDisconnectSubscription = this.readerService.setStatusListener().subscribe((response) => {
      if (response.hasOwnProperty('connected')) {
        this.checkIfReaderIsConnected();
      }
    }, (error) => {
      console.log(this.tag, 'Error setting reader listener', error);
    });
  }*/

  checkIfReaderIsConnected() {
    this.readerProperties = [];
    this.suscReaderIsConnected = this.readerService.isConnected(true).subscribe(
      (response: any) => {
        // If it is not connected, but simulator is enabled, then continue
        if (response || this.simulatorService.isSimulatorEnabled) {
          console.log(this.tag, 'Reader connected, getting information');
          this.getReaderInformation();
          this.isReaderConnected = true;
        } else {
          console.log(this.tag, 'Reader not connected, simulator disabled, skip get information');
          this.isReaderConnected = false;
        }

        console.log(this.tag, response);

        // this.processTag(tagResponse);
      }, (error) => {
        console.log(this.tag, 'Error checking if reader is connected', error);
        this.isReaderConnected = false;
        if (this.simulatorService.isSimulatorEnabled) {
          console.log(this.tag, 'Error checking if reader is connected, but simulator enabled, getting information');
          this.getReaderInformation();
        }
      }
    );
  }

  saveReaderVolumeStorage() {
    /*ion change sound volume*/
    console.log(this.tag, "on change sound volume", this.readerVolume);
    this.storage.set(STORAGE_READER_SOUND_LEVEL, this.readerVolume);
  }

  savePendingCycleCounts() {
    this.cycleCountService.getPendingCount().then((count) => {
      if (count > 0) {
        this.cycleCountService.checkPending(true);
      }
    });
  }

  goToPairSled() {
    let returnNavParams = {};
    returnNavParams[NAV_PARAM_BACK_TO_MENU] = true;
    if (this.returnPage) {
      returnNavParams[NAV_PARAM_RETURN_PAGE] = this.returnPage;
    }
    this.navCtrl.push(DeviceSelectPage, returnNavParams);
  }


  getAppInformation() {
    console.log(this.tag, 'Getting App Information');
    this.vizixService.timestamp().subscribe((response: { timestamp: number }) => {
        const local = new Date().getTime();
        const currentOffset = local - response.timestamp;
        this.getGeneralAppInformation();
        //setting information the Host of Vizix

        this.appProperties.push({
          "id": "viZixTime",
          "label": this.translate.instant('setup.labels.viZixTime'),
          "value": "" + this.datePipe.transform(response.timestamp, 'yyyy-MM-dd hh:mm:ss a') + " (" + this.vizixService.vizixTime() + "ms)"
        });
        this.startClock(response.timestamp, this.appProperties.find((val) => val.id === "viZixTime"));
        this.appProperties.push({
          "id": "mobileTime",
          "label": this.translate.instant('setup.labels.mobileTime'),
          "value": "" + this.datePipe.transform(new Date().getTime(), 'MM-dd-yyyy hh:mm:ss a') + " (" + new Date().getTime() + " ms)",
        });
        this.startClock(new Date().getTime(), this.appProperties.find((val) => val.id === "mobileTime"));
        this.appProperties.push({
          "id": "viZIxWaitTime",
          "label": this.translate.instant('setup.labels.viZIxWaitTime'),
          "value": currentOffset + " ms"
        });
        this.appProperties.push({
          "label": this.translate.instant('app_config.update_remaining_delay'),
          "value": this.vizixService.configurationApp.CycleCountConfiguration.UpdateRemainingDelay.value + " s"
        });
      }, error2 => {
        console.error(this.tag, error2);
        console.error(this.tag, "Not connected to vizix service");
        this.getGeneralAppInformation();
      }
    );

  }

//Most General App Information
  getGeneralAppInformation() {

    this.appVersion.getAppName().then((data) => {
      console.log(this.tag, data);
      this.appName = data;
      this.appProperties.push({
        "label": this.translate.instant('app_config.application_name'),
        "value": this.appName
      });
      this.cdr.detectChanges();
    }, () => {
      console.log(this.tag, "Error");
      this.appName = DEFAULT_APP_NAME;
      this.appProperties.push({
        "label": this.translate.instant('app_config.application_name'),
        "value": this.appName
      });
    });


    console.log(this.tag, 'Getting Version Number');
    this.appVersion.getVersionNumber().then((data) => {
      console.log(this.tag, data);
      this.appVersionString = data;
      this.appProperties.push({
        "label": this.translate.instant('app_config.application_version'),
        "value": this.appVersionString
      });
      this.cdr.detectChanges();
    }, () => {
      console.log(this.tag, "Error");
      this.appVersionString = DEFAULT_APP_VERSION;
      this.appProperties.push({
        "label": this.translate.instant('app_config.application_version'),
        "value": this.appVersionString
      });
    });

    this.appProperties.push({"label": this.translate.instant('app_config.os'), "value": this.os});

    this.appProperties.push({
      "label":this.translate.instant('app_config.url'),
      "value":this.vizixService.baseURLToShow
    });

    console.log(this.tag, 'Getting UUID');
    this.vizixEventService.GetUUID().then((uuid) => {
      this.appProperties.push({"label": this.translate.instant('app_config.uuid'), "value": uuid})
    }, (defaultUUID) => {
      this.appProperties.push({"label": this.translate.instant('app_config.uuid'), "value": defaultUUID});
    });
    this.cdr.detectChanges();

    //setting information the ConfigurationThing name
    // if(!isUndefined(this.vizixService.configurationApp.name)||this.vizixService.configurationApp.name!=null){
    if (!isUndefined(this.vizixService.configurationApp) || this.vizixService.configurationApp != null) {
      this.appProperties.push({
        "label": this.translate.instant('app_config.configuration_thing'),
        "value": this.vizixService.configurationApp.name
      });
    }
    else {
      console.log(this.tag, "Error getting Configuration Thing");
    }

  }

  startClock(time: number, model: { id: string, label: string, value }) {
    const tick = (time: number) => {
      const clock = setTimeout(() => {
        const updatedTime = time + 1000;
        model.value = "" + this.datePipe.transform(updatedTime, 'MM-dd-yyyy hh:mm:ss a') + " (" + updatedTime + " ms)";
        tick(updatedTime);
      }, 1000);
      this.timeoutTicks.push(clock);
    };
    tick(time);
  }

  /**
   * Update Clocks
   */
  updateClocks(): void {
    this.vizixService.timestamp().subscribe((response: { timestamp: number }) => {
      this.clearTimeouts();
      const local = new Date().getTime();
      const currentOffset = local - response.timestamp;
      localStorage.setItem(STORAGE_TIME_OFFSET, currentOffset.toString());
      this.appProperties.find((val) => val.id === "viZIxWaitTime").value = currentOffset + " ms";
      this.startClock(new Date().getTime(), this.appProperties.find((val) => val.id === "mobileTime"));
      this.startClock(response.timestamp, this.appProperties.find((val) => val.id === "viZixTime"));
    });
  }

  getReaderInformation() {
    // Check the saved reader volume
    this.ifExistsConfigurationSound();

    // If simulator is enabled and no reader is connected, we assume simulator constants
    if (this.isSimulatorEnabled && !this.isReaderConnected) {

      // let level_sounds = SIMULATOR_READER_SOUND_LEVELS;
      // this.readerVolume = SIMULATOR_READER_SOUND_LEVELS - 1;

      // this.maxLevelSound = level_sounds - 1;
      this.readerName = SIMULATOR_READER_NAME;
      // this.readerVolume = this.maxLevelSound;
      this.readerProperties.push({
        "label": this.translate.instant('app_config.address'),
        "value": SIMULATOR_READER_ADDRESS
      });
      this.readerProperties.push({
        "label": this.translate.instant('app_config.battery'),
        "value": SIMULATOR_READER_BATTERY
      });

      this.readerProperties.push({
        "label": this.translate.instant('app_config.max_power'),
        "value": SIMULATOR_READER_MAX_POWER
      });
      this.readerProperties.push({
        "label": this.translate.instant('app_config.min_power'),
        "value": SIMULATOR_READER_MIN_POWER
      });
      this.readerProperties.push({
        "label": this.translate.instant('app_config.model'),
        "value": SIMULATOR_READER_MODEL
      });
      this.readerProperties.push({
        "label": this.translate.instant('app_config.sound_levels'),
        "value": SIMULATOR_READER_SOUND_LEVELS
      });
      this.readerProperties.push({"label": this.translate.instant('app_config.type'), "value": SIMULATOR_READER_TYPE});
      // this.getReaderConfiguration();

      this.readerProperties.push({
        "label": this.translate.instant('app_config.manufacturer'),
        "value": SIMULATOR_READER_MANUFACTURER
      });

    } else {
      this.readerName = this.readerService.readerInformation.name;
      this.readerProperties.push({
        "label": this.translate.instant('app_config.address'),
        "value": this.readerService.readerInformation.address
      });
      this.getReaderConfiguration();
    }
  }


  getReaderConfiguration() {
    this.suscReaderGetConfig = this.readerService.getConfiguration().subscribe(
      (config: ReaderThingConfiguration) => {
        // Add the information for the first part of the box.
        this.readerProperties.push({
          "label": this.translate.instant('app_config.battery'),
          "value": config.battery
        });
        this.readerProperties.push({
          "label": this.translate.instant('app_config.max_power'),
          "value": this.readerService.readerInformation.maxPower
        });
        this.readerProperties.push({
          "label": this.translate.instant('app_config.min_power'),
          "value": this.readerService.readerInformation.minPower
        });
        this.readerProperties.push({
          "label": this.translate.instant('app_config.model'),
          "value": this.readerService.readerInformation.model
        });
        this.readerProperties.push({
          "label": this.translate.instant('app_config.type'),
          "value": this.readerService.readerInformation.type
        });
        // Add the rest of information for the second part of the box
        const objPower = {
          "label": this.translate.instant('app_config.power'),
          "value": config.power
        };
        if (!this.mapReaderProperties.hasOwnProperty("power")) {
          this.mapReaderProperties["power"] = this.readerProperties.length;
          this.readerProperties.push(objPower);
        } else {
          this.readerProperties[this.mapReaderProperties["power"]] = objPower;
        }

        if (!this.firstReaderInformationWasUpdated) {
          this.firstReaderInformationWasUpdated = true;

          const objQ = {
            "label": this.translate.instant('app_config.q'),
            "value": config.q
          };
          if (!this.mapReaderProperties.hasOwnProperty("q")) {
            this.mapReaderProperties["q"] = this.readerProperties.length;
            this.readerProperties.push(objQ);
          } else {
            this.readerProperties[this.mapReaderProperties["q"]] = objQ;
          }

          const objSession = {
            "label": this.translate.instant('app_config.session'),
            "value": config.session
          };
          if (!this.mapReaderProperties.hasOwnProperty("session")) {
            this.mapReaderProperties["session"] = this.readerProperties.length;
            this.readerProperties.push(objSession);
          } else {
            this.readerProperties[this.mapReaderProperties["session"]] = objSession;
          }

          const objSelect = {
            "label": this.translate.instant('app_config.select'),
            "value": config.select
          };
          if (!this.mapReaderProperties.hasOwnProperty("select")) {
            this.mapReaderProperties["select"] = this.readerProperties.length;
            this.readerProperties.push(objSelect);
          } else {
            this.readerProperties[this.mapReaderProperties["select"]] = objSelect;
          }

          const objTarget = {
            "label": this.translate.instant('app_config.target'),
            "value": config.target
          };
          if (!this.mapReaderProperties.hasOwnProperty("target")) {
            this.mapReaderProperties["target"] = this.readerProperties.length;
            this.readerProperties.push(objTarget);
          } else {
            this.readerProperties[this.mapReaderProperties["target"]] = objTarget;
          }
        }

        const objSoundEnabled = {
          "label": this.translate.instant('app_config.sound_enabled'),
          "value": config.ReaderSoundEnabled ? this.translate.instant('global.yes') : this.translate.instant('global.no')
        };
        if (!this.mapReaderProperties.hasOwnProperty("ReaderSoundEnabled")) {
          this.mapReaderProperties["ReaderSoundEnabled"] = this.readerProperties.length;
          this.readerProperties.push(objSoundEnabled);
        } else {
          this.readerProperties[this.mapReaderProperties["ReaderSoundEnabled"]] = objSoundEnabled;
        }

        this.readerProperties.push({
          "label": this.translate.instant('app_config.manufacturer'),
          "value": this.readerService.readerInformation.manufacture
        });

        this.cdr.detectChanges();
        // const objSoundLevel = {
        //   "label": this.translate.instant('app_config.sound_level'),
        //   "value": config.ReaderSoundLevel
        // };
        // if (!this.mapReaderProperties.hasOwnProperty("ReaderSoundLevel")) {
        //   this.mapReaderProperties["ReaderSoundLevel"] = this.appProperties.length;
        //   this.appProperties.push(objSoundLevel);
        // } else {
        //   this.appProperties[this.mapReaderProperties["ReaderSoundLevel"]] = objSoundLevel;
        // }
      }, error => {
        console.log(this.tag, 'Error getting configuration', error);
      });

    // After getting the reader information, we stop
    this.stopReader();
  }

  initCycleCountProgress() {
    this.cycleCountInterval = setInterval(() => { // TODO: MOVE TO EVENTS
      this.isCycleCountRunning = this.cycleCountService.uploadProgress > 0;

      if (this.isCycleCountRunning) {
        this.cycleCountProgress = Math.trunc(this.cycleCountService.uploadProgress);
        this.cdr.detectChanges();
      } else {
        this.cycleCountProgress = 0;
      }
    }, 300);
  }

  goBack() {
    if (!this.isPopActive && !this.isAlertShowing) {
      this.isPopActive = true;
      this.navCtrl.pop().then(() => {
      });
    }
  }

  /*removeStorageSoundVolume(){
    this.storage.remove(STORAGE_READER_SOUND_LEVEL);
  }

  getStorageConfigurationSound(){
    this.storage.get(STORAGE_READER_SOUND_LEVEL).then((levelSound) => {
      if (!levelSound&&levelSound!=0) {
        return false;
      }
      else{
        return true;
      } }, rejectedReason => {
      return false;
    });
  }*/

  ifExistsConfigurationSound() {

    this.storage.get(STORAGE_READER_SOUND_LEVEL).then((levelSound) => {

      console.log(this.tag, 'Sound Level from storage', levelSound);

      if (!levelSound && levelSound != 0) {
        this.readerVolume = this.maxLevelSound;
        this.saveReaderVolumeStorage();
        this.cdr.detectChanges();
      }
      else {
        this.readerVolume = levelSound;
        this.cdr.detectChanges();
      }
    }, rejectedReason => {
      this.readerVolume = this.maxLevelSound;
      this.saveReaderVolumeStorage();
      this.cdr.detectChanges();
    });
  }


  alertDisconnetReaderConfirm() {
    let alert = this._alertCtrl.create({
      title: this.translate.instant('app_config.alerts.disconnect_reader.title'),
      subTitle: this.translate.instant('app_config.alerts.disconnect_reader.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('app_config.alerts.disconnect_reader.cancel'),
          role: 'cancel',
          handler: () => {
            console.log(this.tag, 'Cancel clicked');
            this.isAlertShowing = false;
          }
        },
        {
          text: this.translate.instant('app_config.alerts.disconnect_reader.ok'),
          handler: () => {
            this.isAlertShowing = false;
            this.isReaderConnected = false;
            this.setReaderDisconnected();
          }
        }
      ]
    });
    this.isAlertShowing = true;
    alert.present();
  }

  private setReaderDisconnected() {
    this.suscReaderDisconected = this.readerService.disconnect().subscribe(
      (response: any) => {
        console.log(this.tag, response);
        console.log(this.tag, "Reader Disconnected Successfully");
        this.cdr.detectChanges();
        this.content.resize();
        this.checkIfReaderIsConnected();
      }, (error) => {
        console.log(this.tag, "Error Disconnecting the reader");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-config/app-config.ts